import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

// Silent re-login: on a 401, rotate the refresh cookie once and retry the original request.
const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;
export const refreshSession = () => {
  if (!refreshing) {
    refreshing = api.post("/auth/refresh", null, { _skipRefresh: true }).finally(() => { refreshing = null; });
  }
  return refreshing;
};

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status !== 401 || cfg._retried || cfg._skipRefresh || NO_REFRESH.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    try {
      await refreshSession();
    } catch {
      return Promise.reject(error);
    }
    return api({ ...cfg, _retried: true });
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
